import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from "vue";
import type { IMatch } from "~src/interfaces";
import MatchEnum from "~src/enums/MatchEnum";
import { usecommonStore } from "~src/stores/CommonStore";

const __default__ = {};

interface IProps {
  match: IMatch;
  size?: number;
  modifyClass?: string;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ScoreVs',
  props: {
    match: {},
    size: { default: 42 },
    modifyClass: {}
  },
  setup(__props: any) {

const commonStore = usecommonStore();

const props = __props;

const siteName = computed(() => commonStore.getSiteName);

const isShowScore = computed(() => {
  return [...MatchEnum.LIST_STATUS_PLAYING, MatchEnum.STATUS_END].includes(
    props.match.status_id
  );
});

const homeScore = computed(() => {
  let score = props.match.home_scores[0];

  // Trường hợp đá hiệp phụ
  if (props.match.home_scores[5] > 0) {
    score = props.match.home_scores[5];

    return score;
  }

  return score;
});

const awayScore = computed(() => {
  let score = props.match.away_scores[0];

  // Trường hợp đá hiệp phụ
  if (props.match.away_scores[5] > 0) {
    score = props.match.away_scores[5];

    return score;
  }

  return score;
});

return (_ctx: any,_cache: any) => {
  return (isShowScore.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([
      `as-score-vs as-score-vs__num as-score-vs__${_ctx.size} as-score-vs-${siteName.value}`,
      {
        [`as-score-vs-${siteName.value}__home-win`]: homeScore.value > awayScore.value,
        [`as-score-vs-${siteName.value}__away-win`]: homeScore.value < awayScore.value,
        [`as-score-vs-${siteName.value}__draw`]: homeScore.value === awayScore.value,
        [`as-score-vs-${siteName.value}-${_ctx.modifyClass}`]: _ctx.modifyClass,
      },
    ])
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["as-home-score", {
        'as-winner': homeScore.value > awayScore.value,
      }])
        }, _toDisplayString(homeScore.value), 3),
        _cache[0] || (_cache[0] = _createTextVNode(" : ")),
        _createElementVNode("span", {
          class: _normalizeClass(["as-away-score", {
        'as-winner': homeScore.value < awayScore.value,
      }])
        }, _toDisplayString(awayScore.value), 3)
      ], 2))
    : (_openBlock(), _createElementBlock("span", {
        key: 1,
        class: _normalizeClass(`as-score-vs as-score-vs__${_ctx.size} as-score-vs__only-text as-score-vs__only-text-${siteName.value}`)
      }, " VS ", 2))
}
}

})